import { render, staticRenderFns } from "./SaleWizardNavigation.vue?vue&type=template&id=31faac80&"
import script from "./SaleWizardNavigation.vue?vue&type=script&lang=js&"
export * from "./SaleWizardNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports